module.exports = __webpack_public_path__ + "static/img/iPadPro2020.245e0ad2.png";